import styles from "./dateSelect.module.scss";
import { TextField } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { isValid } from "date-fns";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import React from "react";


const DateSelect = (props: DateSelectProps) => {
    const { label, selectedDate, handleDateChange, filter, required, disableDate, errMess } = props;
    const [error, setError] = React.useState<boolean>(false);

    return <div className={filter ? `${styles.date_select}` : `${styles.date_group}`}>
        {label && label !== undefined && <div className={filter ? `${styles.label}` : `${styles.label} ${styles.label_height}`}><div>{label}{required && <span>*</span>}</div></div>}

        {
        <DesktopDatePicker
            onChange={(date: Date | null) => {
                if (!isValid(date)) {
                    setError(true)
                } else {
                    setError(false)
                } 
                handleDateChange(date)
            }}
            value={selectedDate}
            mask="____/__/__"
            inputFormat="yyyy/MM/dd"
            renderInput={(params: any) => <TextField fullWidth {...params}
                InputLabelProps={{ shrink: false }}
                sx={{
                    '& .MuiIconButton-root': {
                        color: "#1E53A3"
                    },
                    '& .MuiOutlinedInput-root': {
                        borderColor: required && error ? "#EB4E4E" : required && errMess !== undefined ? "#EB4E4E" : ""
                    }
                }}
            />}
            components={{
                OpenPickerIcon: CalendarTodayIcon
            }}
            shouldDisableDate={(day) => disableDate ? disableDate(day) : false}
        />
        }
        {
          (error || errMess) ? (
            <div className={styles.err_mess}>{errMess ?? "入力必須です"}</div>
          ) : (
            <></>
          )
        }
    </div>
}

export interface DateSelectProps {
    label?: string;
    selectedDate: Date | null;
    handleDateChange: (date: Date | null) => void;
    filter?: boolean;
    required?: boolean;
    time?:boolean;
    disableDate?: (day: Date) => boolean;
    errMess?: string
}

export default DateSelect;